export default (state = false) => state;
